module.exports = __webpack_public_path__ + "img/logop3.80014c54.png";